import { FormActions, Modal, Paragraph, ProgressIndicator, Space } from 'ui';

type P = {
  onClose: () => void;
  onSubmit: () => void;
};

const TelehealthRequestNoticeContent = ({ onClose, onSubmit }: P) => (
  <>
    <Space orientation="vertical" size="large">
      <ProgressIndicator
        progressProperties={{ size: 'extra-small' }}
        step={1}
        textProperties={{ type: 'title' }}
        total={3}
      />
      <Paragraph type="danger">
        If you are experiencing a medical emergency or life-threatening medical condition, do NOT continue to request a
        virtual visit.
      </Paragraph>
      <Paragraph>
        These symptoms include difficulty breathing or shortness of breath, chest pain or discomfort, dizziness,
        confusion, severe or persistent vomiting, and/or flu-like symptoms that improve then worsen again. Instead,
        immediately call 911 or go to your nearest emergency department.
      </Paragraph>
      <Paragraph>
        {`By clicking “Continue" you are acknowledging that you are not experiencing a medical emergency and will continue to next step.`}
      </Paragraph>
    </Space>

    <Modal.HugContent.Footer>
      <FormActions
        right={{ children: 'Cancel', onClick: onClose }}
        submit={{
          children: 'Continue',
          onClick() {
            onSubmit();
          },
        }}
      />
    </Modal.HugContent.Footer>
  </>
);

export default TelehealthRequestNoticeContent;
